import React, { useEffect } from 'react';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';

import Home from './components/Home';
import ArticlePage from './components/ArticlePage';
import RoutingTestPage from './components/RoutingTestPage';

const ScrollToTop: React.FC = () => {
  const { pathname, state } = useLocation();
  useEffect(() => {
    if (!(state as any)?.scrollTo) {
      window.scrollTo(0, 0);
    }
  }, [pathname, state]);
  return null;
};

const App: React.FC = () => {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/articles/:id" element={<ArticlePage />} />
        {/* ルーティング動作確認用（ナビゲーション非表示） */}
        <Route path="/routing-test" element={<RoutingTestPage />} />
      </Routes>
    </BrowserRouter>
  );
};

export default App;
